import React from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '../../../../display/Typography';
import { MainButton } from '../../../../inputs/buttons/MainButton';
import AlertIcon from '../../../../../assets/icons/alert-icon.svg';
// Las piezas del aviso de permisos de fotos: la misma situación (falta un
// permiso) tiene que verse igual en toda la app.
import {
  IconImg,
  OptionChip,
  TextGroup,
} from '../../BackgroundLocationRequiredModal/styles';
import { Steps } from '../../PhotoPermissionsRequiredModal/styles';
import { PermissionNotice } from '../styles';
import type { CameraDenial } from '../cameraPermission';

interface CameraPermissionNoticeProps {
  mode: CameraDenial;
  /** Vuelve a abrir la cámara, que es lo que hace salir el diálogo de Android. */
  onContinue: () => void;
  onOpenSettings: () => void;
}

/**
 * Qué hacer cuando la cámara no tiene permiso en la APK. Como el aviso de
 * permisos de fotos: para qué sirve, pasos, la etiqueta real de Android en su
 * recuadro y un botón que siempre funciona. Solo nombra la opción buena.
 *
 * Antes solo decía «Permisos denegados»: tras dos negativas Android ya no
 * pregunta, y el operario no tenía cómo saber que se arregla en Ajustes
 * (visto en la W el 25-09-2026).
 *
 * Va en una tarjeta blanca como los demás modales, no en el visor negro de la
 * cámara: es un aviso nuestro, no la cámara.
 */
export const CameraPermissionNotice = ({
  mode,
  onContinue,
  onOpenSettings,
}: CameraPermissionNoticeProps): JSX.Element => {
  const { t } = useTranslation(['modals']);
  const text = (name: string): string => t(`modals:camera.permission.${name}`);
  const inSettings = mode === 'settings';

  return (
    <PermissionNotice role="alert">
      <IconImg src={AlertIcon} alt="" />
      <TextGroup>
        <Typography size="L" variant="semiBold">
          {text('title')}
        </Typography>
        <Typography size="M">{text('reason')}</Typography>
      </TextGroup>
      <TextGroup>
        {inSettings && <Typography size="M">{text('settingsIntro')}</Typography>}
        <Steps>
          {inSettings ? (
            <>
              <li>{text('settingsStep1')}</li>
              <li>{text('settingsStep2')}</li>
              <li>{text('settingsStep3')}</li>
            </>
          ) : (
            <>
              <li>{text('askStep1')}</li>
              <li>{text('askStep2')}</li>
            </>
          )}
        </Steps>
      </TextGroup>
      <OptionChip>{inSettings ? text('settingsOption') : text('askOption')}</OptionChip>
      <MainButton
        text={inSettings ? text('openSettings') : text('continue')}
        onClick={inSettings ? onOpenSettings : onContinue}
      />
    </PermissionNotice>
  );
};

export default CameraPermissionNotice;
